export class PiperingBossThreadedRodModel {
    _id: string;
    id: number;
    piperingBossId: number;
    threadedRodId: number;
    threadedRodName: String;
    depth: number;

    constructor(_id = null,
        id = null,
        piperingBossId = null,
        threadedRodId = null,
        threadedRodName = null,
        depth = null,

    ) {
        this._id = _id;
        this.id = id;
        this.piperingBossId = piperingBossId;
        this.threadedRodId = threadedRodId;
        this.threadedRodName = threadedRodName;
        this.depth = depth;
    }
}
